import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getUnreadRequestsCount } from '../api/productRequests'

export const useProductRequestsStore = defineStore('productRequests', () => {
  // 未讀留言數量
  const unreadCount = ref(0)
  
  // 更新間隔ID
  let updateInterval = null
  
  // 獲取未讀留言數量
  const fetchUnreadCount = async () => {
    try {
      const count = await getUnreadRequestsCount()
      unreadCount.value = count
      return count
    } catch (error) {
      console.error('獲取未讀留言數量失敗:', error)
      unreadCount.value = 0
      return 0
    }
  }
  
  // 開始定期更新
  const startPolling = () => {
    // 立即獲取一次
    fetchUnreadCount()
    
    // 每30秒更新一次
    if (!updateInterval) {
      updateInterval = setInterval(fetchUnreadCount, 30000)
    }
  }
  
  // 停止定期更新
  const stopPolling = () => {
    if (updateInterval) {
      clearInterval(updateInterval)
      updateInterval = null
    }
  }
  
  // 手動刷新未讀數量（用於狀態變更後立即更新）
  const refreshUnreadCount = () => {
    return fetchUnreadCount()
  }
  
  // 重置未讀數量
  const resetUnreadCount = () => {
    unreadCount.value = 0
  }
  
  return {
    unreadCount,
    fetchUnreadCount,
    startPolling,
    stopPolling,
    refreshUnreadCount,
    resetUnreadCount
  }
})
